<div class="action-row">
  <div class="action-row__header">
    <button
      type="button"
      cdkDragHandle
      class="action-row__drag-handle"
    >
      <ui-svg-icon svgIcon="grip-vertical" size="small"></ui-svg-icon>
    </button>
    <span class="action-row__order">{{ action.order + 1 }}.</span>

    <ui-form-field
      class="action-row__type"
      type="select"
      [formControl]="typeControl"
      [placeholder]="'workflows.builder.select_action' | translate"
      [options]="typeOptions"
      (mousedown)="$event.stopPropagation()"
      (pointerdown)="$event.stopPropagation()"
    ></ui-form-field>

    <!-- Locked rows show the lock in place of the remove button: without it a row
         with no delete affordance just looks broken. -->
    <span
      *ngIf="locked; else removeButton"
      class="action-row__lock"
      [matTooltip]="'workflows.builder.locked_action_tooltip' | translate"
      matTooltipPosition="above"
    >
      <ui-svg-icon svgIcon="lock" size="medium"></ui-svg-icon>
    </span>
    <ng-template #removeButton>
      <ui-button
        class="action-row__remove-btn"
        type="transparent"
        icon="close-cc"
        iconSize="medium"
        (click)="remove()"
        (mousedown)="$event.stopPropagation()"
        (pointerdown)="$event.stopPropagation()"
      ></ui-button>
    </ng-template>
  </div>

  <div
    class="action-row__params"
    *ngIf="selectedDescriptor"
    (mousedown)="$event.stopPropagation()"
    (pointerdown)="$event.stopPropagation()"
  >
    <ng-container *ngFor="let param of selectedDescriptor.params">
      <ng-container [ngSwitch]="param.controlType">
        <ui-form-field
          *ngSwitchCase="'select'"
          class="action-row__param"
          type="select"
          [formControl]="paramControls[param.key]"
          [placeholder]="('common.select' | translate) + '...'"
          [options]="getParamEnumOptions(param.optionsEndpoint)"
        ></ui-form-field>

        <ui-form-field
          *ngSwitchCase="'textarea'"
          class="action-row__param action-row__param--wide"
          type="textarea"
          [formControl]="paramControls[param.key]"
          [placeholder]="param.i18nLabel | translate"
        ></ui-form-field>

        <div *ngSwitchCase="'mention_textarea'" class="action-row__param action-row__param--wide action-row__mention-wrapper">
          <textarea
            class="action-row__mention-textarea"
            [formControl]="paramControls[param.key]"
            [placeholder]="param.i18nLabel | translate"
            [mention]="getMentionables()"
            [mentionConfig]="mentionConfig"
            [mentionListTemplate]="mentionTemplate"
            (itemSelected)="onMentionSelected($event, param.key)"
            (opened)="mentionListOpen = true"
            (closed)="mentionListOpen = false"
            (mousedown)="$event.stopPropagation()"
            (pointerdown)="$event.stopPropagation()"
          ></textarea>
        </div>

        <div *ngSwitchCase="'template_textarea'" class="action-row__param action-row__param--wide action-row__template-editor">
          <ui-form-field
            #templateField
            type="textarea"
            [fullWidth]="true"
            [formControl]="paramControls[param.key]"
            [placeholder]="param.i18nLabel | translate"
            (mousedown)="$event.stopPropagation()"
            (pointerdown)="$event.stopPropagation()"
          ></ui-form-field>
          <div class="action-row__variables" *ngIf="visibleVariables(param).length">
            <span class="action-row__variables-label">{{ 'workflows.params.insert' | translate }}</span>
            <button
              type="button"
              class="action-row__variable-chip"
              *ngFor="let variable of visibleVariables(param)"
              (click)="insertVariable(param.key, variable.key)"
              (mousedown)="$event.stopPropagation()"
              (pointerdown)="$event.stopPropagation()"
            >{{ variableToken(variable.key) }}</button>
          </div>
          <div class="action-row__template-hint">
            <ui-svg-icon class="action-row__template-hint-icon" svgIcon="ai-volta-icon" size="small"></ui-svg-icon>
            <span>{{ 'workflows.actions.send_reply_hint' | translate }}</span>
          </div>
        </div>

        <ui-form-field
          *ngSwitchCase="'number'"
          class="action-row__param"
          type="number"
          [formControl]="paramControls[param.key]"
          [placeholder]="param.i18nLabel | translate"
        ></ui-form-field>

        <div *ngSwitchCase="'toggle'" class="action-row__param action-row__toggle">
          <mat-slide-toggle [formControl]="paramControls[param.key]"></mat-slide-toggle>
          <span class="action-row__toggle-label">{{ param.i18nLabel | translate }}</span>
        </div>

        <app-workflow-order-modifications
          *ngSwitchCase="'order_field_modifications'"
          class="action-row__param action-row__param--wide"
          [param]="param"
          [enumCache]="enumCache"
          [value]="paramControls[param.key].value"
          (valueChange)="paramControls[param.key].setValue($event)"
        ></app-workflow-order-modifications>
        
        <div *ngSwitchCase="'email_list'" class="action-row__param action-row__param--wide action-row__email-list">
          <mat-chip-list #chipList [attr.aria-label]="param.i18nLabel | translate">
            <mat-chip
              *ngFor="let email of emailListValues[param.key]"
              [removable]="true"
              (removed)="removeEmail(param.key, email)"
            >
              {{ email }}
              <button matChipRemove type="button">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
            <input
              [formControl]="emailInputControls[param.key]"
              [placeholder]="'workflows.params.recipients_placeholder' | translate"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="true"
              (matChipInputTokenEnd)="addEmail(param.key, $event)"
              (mousedown)="$event.stopPropagation()"
              (pointerdown)="$event.stopPropagation()"
            />
          </mat-chip-list>
        </div>

        <ui-form-field
          *ngSwitchDefault
          class="action-row__param"
          type="text"
          [formControl]="paramControls[param.key]"
          [placeholder]="param.i18nLabel | translate"
        ></ui-form-field>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #mentionTemplate let-item="item">
  <span class="mention-avatar" [style.background-color]="item.color">{{ item.initials }}</span>
  <span class="mention-name">{{ item.name }}</span>
</ng-template>
